import { Card } from "antd";

export const Dashboard = () => {
  return (
    <Card title="Dashboard">
      here will be basic overview of all things happening
    </Card>
  );
};
